<ion-grid class="ion-no-padding" *ngIf="(levels$ | async)?.loading === false">
  <ion-row align-items-start class="ion-justify-content-center ion-align-items-center">
    <ion-col class="ion-no-padding ion-no-margin">
    <ionic-selectable
      *ngIf="(levels$ | async)?.loading === false"
      [(ngModel)]="levelId"
      [items]="(levels$ | async)?.data || []"
      itemValueField="id"
      itemTextField="name"
      [canSearch]="true"
      [hasInfiniteScroll]="true"
      [shouldStoreItemValue]="true"
      (onInfiniteScroll)="getMoreLevels($event)"
      (onSearch)="searchLevels($event)"
      closeButtonSlot="end"
      [disabled]="disabled || !zoneId"
      #levelsSelectComponent
    >
      <ng-template ionicSelectablePlaceholderTemplate>
        Level
      </ng-template>
      <ng-template ionicSelectableFooterTemplate>
        <ion-toolbar>
          <ion-row>
            <ion-col>
              <ion-button expand="full" (click)="createLevel()">
                Create Level
              </ion-button>
            </ion-col>
            <ion-col>
              <ion-button expand="full" (click)="selectLevel()">
                OK
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-toolbar>
      </ng-template>
    </ionic-selectable>

    </ion-col>
    <ion-col align-self-end size="auto" *ngIf="levelId && !disabled">
      <ion-button
        size="default"
        (click)="clearLevel()"
        fill="clear"
        class="clear-button"
      >
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-col>
  </ion-row>
</ion-grid>

<ion-spinner name="dots" *ngIf="(levels$ | async)?.loading"></ion-spinner>
